import { useSWRConfig } from 'swr';
import { deleteFetcher } from '@/api/fetchers';
import { useParams } from 'react-router-dom';
import { displayError } from '@/utils/error/errorHandler';

export default function useDeleteApprovedAbsence() {
  const { employeeId } = useParams<{ employeeId: string }>();
  const { mutate } = useSWRConfig();

  const deleteApprovedAbsence = async (id: number) => {
    try {
      if (employeeId === undefined)
        throw new Error('employeeId is undefined. Check URL.');

      await deleteFetcher(
        `/employees/${employeeId}/absences/${id}/confirmation`
      );

      await mutate(`/employees/${employeeId}/absences`);
    } catch (err) {
      displayError(err);
    }
  };

  return {
    deleteApprovedAbsence,
  };
}
